import React from "react";

import { Sheet, SheetContent, SheetDescription, SheetFooter, SheetHeader, SheetTitle, SheetTrigger } from "@client/shadcn/ui/sheet";
import { Button } from "@client/shadcn/ui/button";
import { interfaces, ServerProjectsForms, ProjectsTemplates_Project_T } from "@reactivated";
import { ProjectForm } from "./ProjectForm";
import { Toaster } from "@client/shadcn/ui/sonner";

interface Props {
    className?: string;
    id: number;
}

export const ProjectEdit = (props: Props) => {
    const [formData, setFormData] = React.useState<ServerProjectsForms>();
    const [tagsList, setTagsList] = React.useState<{name: string}[]>([]);
    const [contactsList, setContactsList] = React.useState<{
        id: number;
        email: string;
        first_name: string;
        last_name: string;
    }[]>([]);
    const [project, setProject] = React.useState<ProjectsTemplates_Project_T>();
    
    const onOpen = async (event: React.MouseEvent) => {
        const response = await fetch(`/projects/${props.id}/`, {
            headers: {
                Accept: "application/json",
            },
        });
        const data: interfaces.ProjectEdit = await response.json();
        setFormData(data.form);
        setTagsList(data.available_tags);
        setContactsList(data.available_contacts);
        setProject(data.project);
    };

    return (
        <Sheet>
            <SheetTrigger asChild>
                <Button variant="secondary" onClick={onOpen}>Edit</Button>
            </SheetTrigger>
            
            <SheetContent className="overflow-y-scroll">
                <SheetHeader>
                    <SheetTitle>Edit project</SheetTitle>
                    <SheetDescription>
                        Make changes to your project here. Click save when you're done.
                    </SheetDescription>
                </SheetHeader>
                {formData && project ? <ProjectForm
                    formData={formData}
                    availableTags={tagsList}
                    availableContacts={contactsList}
                    project={project}
                /> : null}
                <SheetFooter>
                    <Button type="submit" form="projectForm">Save changes</Button>
                </SheetFooter>
                <Toaster />
            </SheetContent>
        </Sheet>
    );
};
